// extracted by mini-css-extract-plugin
export var card = "_6q-0";
export var expandedCard = "_6q-2";
export var paginated = "_6q-1";